import angular from 'angular';
import sourceTableComponent from './sourceTable.component';

let sourceTableModule = angular.module('sourceTable', []).component('sourceTable', sourceTableComponent);

export default sourceTableModule;



// WEBPACK FOOTER //
// ./app/components/sourceTable/sourceTable.js